import React, { useState, useEffect } from 'react';
import './SessionDetail.css';

const SessionDetail = ({ sessionId, organizerId, onClose }) => {
  const [session, setSession] = useState(null);
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('details');

  useEffect(() => {
    loadSessionDetails();
  }, [sessionId]);

  const loadSessionDetails = async () => {
    try {
      const response = await fetch(`/api/organizer/sessions/${sessionId}`, {
        credentials: 'include',
      });
      if (response.ok) {
        const data = await response.json();
        setSession(data.session);
        setInvites(data.invites || []);
      }
    } catch (err) {
      console.error('Failed to load session:', err);
    } finally {
      setLoading(false);
    }
  };

  const copyInviteUrl = (url) => {
    navigator.clipboard.writeText(url);
    alert('Invite URL copied to clipboard!');
  };

  if (loading) {
    return (
      <div className="session-detail-overlay">
        <div className="session-detail-modal">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  if (!session) {
    return null;
  }

  return (
    <div className="session-detail-overlay" onClick={onClose}>
      <div className="session-detail-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Session Details</h2>
          <button onClick={onClose} className="close-btn">
            ×
          </button>
        </div>

        <div className="modal-tabs">
          <button
            className={activeTab === 'details' ? 'active' : ''}
            onClick={() => setActiveTab('details')}
          >
            Details
          </button>
          <button
            className={activeTab === 'invites' ? 'active' : ''}
            onClick={() => setActiveTab('invites')}
          >
            Invites ({invites.length})
          </button>
        </div>

        <div className="modal-content">
          {activeTab === 'details' && (
            <div className="details-tab">
              <div className="detail-row">
                <span className="detail-label">Persona:</span>
                <span className="detail-value">{session.persona}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Topic:</span>
                <span className="detail-value">{session.topic || 'N/A'}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Difficulty:</span>
                <span className="detail-value">{session.difficulty}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Status:</span>
                <span className="detail-value">{session.status}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Session ID:</span>
                <span className="detail-value">{session.session_id}</span>
              </div>
            </div>
          )}

          {activeTab === 'invites' && (
            <div className="invites-tab">
              {invites.length === 0 ? (
                <p className="empty">No invites generated yet.</p>
              ) : (
                <div className="invites-list">
                  {invites.map((invite, index) => {
                    const baseUrl = window.location.origin;
                    const inviteUrl = `${baseUrl}/participant/verify-email?token=${invite.verification_token}&invite=${invite.invite_token}`;
                    return (
                      <div key={index} className="invite-item">
                        <div className="invite-info">
                          <div className="invite-name">{invite.participant_name || 'N/A'}</div>
                          <div className="invite-email">{invite.participant_email}</div>
                          <div className="invite-status">Status: {invite.status}</div>
                        </div>
                        <div className="invite-url">
                          <input type="text" value={inviteUrl} readOnly />
                          <button onClick={() => copyInviteUrl(inviteUrl)}>Copy</button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionDetail;

